/**
 * SkillMatrixLegend.tsx
 * The skill-level legend shown beneath the Skill Matrix grid.
 *
 * Rendered OUTSIDE the scrollable TableContainer (as a sibling below it) so it
 * stays visible when the user scrolls the matrix horizontally to reach more
 * test-type columns. Extracted from SkillMatrixGrid to keep that file under the
 * 600-line cap (CODING-STANDARDS.md).
 */

import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { SkillLevelChip, SKILL_LEVEL_LABELS, SKILL_LEVEL_DESCRIPTIONS } from '../../../../components/schedule/SkillLevelChip';
import { SKILL_LEVELS } from '../../../../constants/scheduleEnums';

export const SkillMatrixLegend: React.FC = () => {
  return (
    <Box
      sx={{
        p: 1.5,
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        gap: 2,
        flexWrap: 'wrap',
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="caption" fontWeight={700} sx={{ mr: 0.5, lineHeight: '24px' }}>
        Legend:
      </Typography>
      {SKILL_LEVELS.map((lvl) => (
        <Tooltip key={lvl} title={SKILL_LEVEL_DESCRIPTIONS[lvl]} arrow placement="top">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <SkillLevelChip level={lvl} size="small" />
            <Typography variant="caption" color="text.secondary">
              {SKILL_LEVEL_LABELS[lvl]}
            </Typography>
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};
